import { AjaxClient } from "app/common/ajax";
import { tt_icon } from "app/common/tooltip";
import * as $ from "jquery";

export class SystemSettings {
    private readonly ajaxClient: AjaxClient;
    private readonly ajaxLoader: string;

    constructor(ajaxClient: AjaxClient, ajaxLoader: string) {
        this.ajaxClient = ajaxClient;
        this.ajaxLoader = ajaxLoader;

        $('tr.type-model input').on('blur', (evt) => {
            const row = $(evt.currentTarget).closest('tr');
            const data: JQuery.PlainObject = {
                key: row.data('key') as string,
                value: $(evt.currentTarget).val()
            };
            const status = row.find('.status');

            status.html(this.ajaxLoader);

            void this.ajaxClient.call<boolean>('/modpanel/system/settings/validate-model', data).then(
                (result: boolean) => {
                    if (result == false) {
                        status.html(tt_icon('warning', 'This model does not exist.',
                            false, ['warning']));
                    } else {
                        status.html(tt_icon('check', `<small>${JSON.stringify(result)}</small>`,
                            false, ['success']));
                    }
                },
                (reason: string) => {
                    status.html(tt_icon('times', `An error occured when validating: ${reason}`,
                        false, ['error']));
                }
            );
        });
    }
}
